import React, { useContext, useEffect } from "react";
import MainContext from "../../context/mainContext";
import styles from "./Admin.module.scss";
import AdminMenu from "./AdminMenu";
import { Outlet } from "react-router";

const Admin: React.FC = () => {
  const { setBanner } = useContext(MainContext);

  useEffect(() => {
    setBanner(undefined);
  });

  return (
    <div className={styles.adminLayout}>
      <div className={styles.menu}>
        <AdminMenu />
      </div>
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
};

export default Admin;
